import { render, staticRenderFns } from "./RolUsers.vue?vue&type=template&id=54d3f5e5&"
import script from "./RolUsers.vue?vue&type=script&lang=js&"
export * from "./RolUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports